import React from 'react';
import {
  BrowserRouter,
  Route,
  Switch
} from 'react-router-dom';
import useAuth from "./components/auth/useAuth";
import firebase, { FirebaseContext } from "./firebase";
import Publico from './publico/Publico';
import RutaProtegida from './components/auth/RutaProtegida';
import HeaderPublico from './publico/layout/HeaderPublico';
import Login from './components/auth/Login';
import ForgotPassword from './components/auth/ForgotPassword';
import { CssBaseline } from '@material-ui/core';
import HeaderPrivado from './privado/layout/HeaderPrivado';
import PagListaCiclos from './privado/pages/PagListaCiclos';
import PagListaCursos from './privado/pages/PagListaCursos';
import PagListaTemas from './privado/pages/PagListaTemas';
import PagProgramacion from './privado/pages/PagProgramacion';
import { makeStyles } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/core/styles';
import theme from './temaConfig';
import PerfilUsuario from './components/auth/PerfilUsuario';
import PagNosotros from './publico/Pages/PagNosotros';
import PagExamenes from './privado/pages/PagExamenes';
import PagAdmExamen from './privado/pages/PagAdmExamen';
import PagExamen from './privado/pages/PagExamen';
import UsuarioState from './privado/contex/UsuarioState';
import AdminLogin from './components/auth/AdminLogin';
import PagAdmUsuarios from './privado/pages/PagAdmUsuarios';


const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
}));

function App() {
  const user = useAuth();
  const classes = useStyles();


  return user !== false ? (
    <BrowserRouter>
      <FirebaseContext.Provider value={{ user, firebase }}>
        <UsuarioState>
          <ThemeProvider theme={theme}>
            {
              user === null ? (
                <div>
                  <HeaderPublico />
                  <Switch>

                    <Route exact path="/login" component={Login} />
                    <Route exact path="/forgot" component={ForgotPassword} />
                    <Route exact path={"/"} component={Publico} />
                    <Route exact path={"/nosotros"} component={PagNosotros} />
                  </Switch>

                </div>
              ) :
                <div>
                  <CssBaseline />
                  <HeaderPrivado />
                  <main className={classes.content}>
                    <div className={classes.toolbar} />
                    <Switch>
                      <RutaProtegida exact={true} path={"/examenes"} Componente={PagExamenes} />
                      <RutaProtegida exact={true} path={"/admusuarios"} Componente={PagAdmUsuarios} />
                      <RutaProtegida exact={true} path={"/examen/:examenId"} Componente={PagExamen} />
                      <RutaProtegida exact={true} path={"/perfil"} Componente={PerfilUsuario} />
                      <RutaProtegida exact={true} path={"/ciclos"} Componente={PagListaCiclos} />
                      <RutaProtegida exact={true} path={"/cursos/:cicloId"} Componente={PagListaCursos} />
                      <RutaProtegida exact={true} path={"/temas/:cursoId"} Componente={PagListaTemas} />
                      <RutaProtegida exact={true} path={"/admin"} Componente={PagProgramacion} />
                      <RutaProtegida exact={true} path={"/admexamenes"} Componente={PagAdmExamen} />
                      <RutaProtegida exact={true} path={"/adm/login"} Componente={AdminLogin} />
                    </Switch>
                  </main>
                </div>
            }
          </ThemeProvider>
        </UsuarioState>
      </FirebaseContext.Provider>
    </BrowserRouter>
  ) : (
      <p>Cargando....</p>
    )
}

export default App;
